<template>
    <button class="MenuIconButton">
        <svg-view name="menu"></svg-view>
    </button>
</template>

<script>
export default {
    name: "MenuIconButton",
};
</script>

<style scoped lang="less">
    @import "~styles/const.less";

    .MenuIconButton {
        position: relative;
        display: block;
        width: 32px;
        height: 32px;
        background: var(--button-bg-color);
        backdrop-filter: blur(27.1828px);
        border-radius: 50%;
        transition: 0.2s background;
        cursor: pointer;

        &:hover {
            background: var(--button-bg-hover-color);

            svg {
                fill: var(--button-icon-hover-color);
            }
        }

        svg {
            position: absolute;
            top: 14px;
            left: 9px;
            width: 15px;
            height: 4px;
            fill: var(--button-icon-color);
            transition: 0.2s fill;
        }
    }
</style>